var render = function () {
  var _vm$value, _vm$value$images, _vm$value2, _vm$value3, _vm$value4, _vm$value5, _vm$value6, _vm$value7, _vm$value8, _vm$value9, _vm$setting, _vm$setting$shippingP, _vm$setting2, _vm$setting2$saleAmou, _vm$value$optionalPro, _vm$value10;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    scopedSlots: _vm._u([{
      key: "fab",
      fn: function fn(_ref) {
        var showScroll = _ref.showScroll,
            scrollTo = _ref.scrollTo;
        return _vm.$vuetify.breakpoint.mobile && _vm.ready ? [_c('v-app-bar', {
          attrs: {
            "app": "",
            "bottom": "",
            "height": "auto",
            "color": "transparent",
            "elevation": "0"
          }
        }, [_c('v-responsive', {
          staticClass: "overflow-visible"
        }, [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: showScroll,
            expression: "showScroll"
          }],
          staticClass: "mt-n40px",
          attrs: {
            "fab": "",
            "absolute": "",
            "top": "",
            "right": "",
            "large": "",
            "tile": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return scrollTo(0, 0);
            }
          }
        }, [_c('div', {
          staticClass: "pa-12px"
        }, [_c('v-icon', {
          staticClass: "my-n4px",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("mdi-chevron-up")]), _c('div', {
          staticClass: "font-size-14 font-weight-medium mb-6px"
        }, [_vm._v("TOP")])], 1)]), _c('v-card', {
          attrs: {
            "elevation": "0"
          }
        }, [_c('div', [_c('v-btn', {
          attrs: {
            "slot": "extension",
            "block": "",
            "text": "",
            "large": "",
            "height": "32",
            "ripple": false,
            "active-class": "no-active"
          },
          on: {
            "click": function click($event) {
              _vm.expand = !_vm.expand;
            }
          },
          slot: "extension"
        }, [_c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.expand,
            expression: "!expand"
          }]
        }, [_vm._v("mdi-chevron-up")]), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.expand,
            expression: "expand"
          }]
        }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-layout', {
          staticClass: "py-1"
        }, [_c('v-flex', {
          staticClass: "px-1",
          attrs: {
            "grow-shrink-0": ""
          }
        }, [_c('v-btn', {
          staticClass: "px-4",
          attrs: {
            "color": "primary",
            "min-width": "auto",
            "x-large": "",
            "outlined": ""
          },
          on: {
            "click": _vm.addToCart
          }
        }, [_c('v-icon', [_vm._v("mdi-cart-outline")])], 1)], 1), _c('v-flex', {
          staticClass: "px-1",
          attrs: {
            "grow-shrink-0": ""
          }
        }, [_c('v-btn', {
          staticClass: "px-4",
          attrs: {
            "color": "primary",
            "min-width": "auto",
            "x-large": "",
            "outlined": ""
          },
          on: {
            "click": _vm.gift
          }
        }, [_c('v-icon', [_vm._v("mdi-gift-outline")])], 1)], 1), _c('v-flex', {
          staticClass: "px-1"
        }, [_c('v-btn', {
          attrs: {
            "block": "",
            "color": "primary",
            "x-large": ""
          },
          on: {
            "click": _vm.order
          }
        }, [_c('span', {
          staticClass: "tit tit--xs white--text"
        }, [_c('v-icon', {
          staticClass: "mr-2 ml-n4"
        }, [_vm._v("mdi-shopping-outline")]), _vm._v("구매하기")], 1)])], 1)], 1)], 1)], 1)], 1)], 1)] : undefined;
      }
    }], null, true)
  }, [[_c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "480",
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-carousel', {
    attrs: {
      "height": "auto",
      "hide-delimiters": "",
      "show-arrows-on-hover": "",
      "show-arrows": 1 < ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$images = _vm$value.images) === null || _vm$value$images === void 0 ? void 0 : _vm$value$images.length)
    }
  }, _vm._l(((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2.images) || [], function (image, index) {
    return _c('v-carousel-item', {
      key: index
    }, [_c('v-img', {
      attrs: {
        "src": _vm.images[index],
        "width": "100%",
        "contain": "",
        "aspect-ratio": 1
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-10"
  }, [[_c('div', {
    staticClass: "tit-wrap mb-20px mb-md-30px"
  }, [_c('div', {
    staticClass: "tit tit--sm primary--text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.value.name)
    }
  })])])], _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [[_c('product-info-field', {
    staticClass: "font-weight-medium",
    attrs: {
      "label": "판매가"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [(_vm$value3 = _vm.value) !== null && _vm$value3 !== void 0 && _vm$value3.costPrice && ((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : _vm$value4.costPrice) != ((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : _vm$value5.salePrice) ? _c('span', {
    staticClass: "red--text text-decoration-line-through body-2 mr-2"
  }, [_vm._v(_vm._s(parseInt((_vm$value6 = _vm.value) === null || _vm$value6 === void 0 ? void 0 : _vm$value6.costPrice).format()) + " 원")]) : _vm._e()]), _c('v-col', [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-20 line-height-1"
  }, [_c('b', [_vm._v(_vm._s(parseInt((_vm$value7 = _vm.value) === null || _vm$value7 === void 0 ? void 0 : _vm$value7.salePrice).format()))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)]], 2), _c('v-divide'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [(_vm$value8 = _vm.value) !== null && _vm$value8 !== void 0 && _vm$value8.writer ? [_c('product-info-field', {
    attrs: {
      "label": "저자"
    }
  }, [_vm._v(_vm._s(_vm.value.writer))])] : _vm._e(), (_vm$value9 = _vm.value) !== null && _vm$value9 !== void 0 && _vm$value9.publisher ? [_c('product-info-field', {
    attrs: {
      "label": "출판사"
    }
  }, [_vm._v(_vm._s(_vm.value.publisher))])] : _vm._e(), [_c('product-info-field', {
    attrs: {
      "label": "배송비"
    }
  }, [_vm.value.shippingCode === 'later' ? _c('span', [_c('b', [_vm._v("착불배송")])]) : _vm._e(), _vm.value.shippingCode === 'self' ? _c('span', [_c('b', [_vm._v(_vm._s(parseInt(_vm.value.shippingPrice).format()))]), _vm._v(" 원")]) : _vm._e(), _vm.value.shippingCode === 'free' ? _c('span', [_c('b', [_vm._v("배송비 무료")])]) : _vm._e(), _vm.value.shippingCode === 'order' ? _c('span', {
    staticClass: "font-size-14 text-end"
  }, [_c('b', [_vm._v(_vm._s("".concat((_vm$setting = _vm.setting) === null || _vm$setting === void 0 ? void 0 : (_vm$setting$shippingP = _vm$setting.shippingPrice) === null || _vm$setting$shippingP === void 0 ? void 0 : _vm$setting$shippingP.lt.format(), "\uC6D0 (").concat((_vm$setting2 = _vm.setting) === null || _vm$setting2 === void 0 ? void 0 : (_vm$setting2$saleAmou = _vm$setting2.saleAmount) === null || _vm$setting2$saleAmou === void 0 ? void 0 : _vm$setting2$saleAmou.format(), "\uC6D0 \uC774\uC0C1\uC740 \uBB34\uB8CC\uBC30\uC1A1)")))])]) : _vm._e()])], [_c('product-info-field', {
    attrs: {
      "label": "배송일정"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', [_vm._v("* 당일 13시까지 주문건에 한하여, 당일 출고됩니다.")]), _c('div', [_vm._v(" 택배사 일정에 따라 2~3일 소요될 수 있습니다. (도서산간 제외)")])])])], _vm._l(_vm.value.info, function (item, index) {
    return _c('product-info-field', {
      key: index,
      staticClass: "mt-4",
      attrs: {
        "label": item.name
      }
    }, [item ? _c('span', [_c('b', [_vm._v(_vm._s(item.value))])]) : _vm._e()]);
  })], 2), (_vm$value$optionalPro = _vm.value.optionalProducts) !== null && _vm$value$optionalPro !== void 0 && _vm$value$optionalPro.length ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('optional-products', {
    attrs: {
      "product": _vm.value
    },
    on: {
      "carts": function carts(cart) {
        return _vm.carts = cart;
      }
    },
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1)] : _vm._e(), !_vm.value.stock || _vm.value.soldout || _vm.value.stock === '0' ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('product-info-field', {
    staticClass: "mt-4 font-weight-bold",
    attrs: {
      "label": "수량"
    }
  }, [_vm._v("품절")])], 1)] : _vm._e(), _c('v-divider'), _vm.carts.length && !_vm.value.soldout && _vm.value.stock !== '0' ? [_c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('cart-list', {
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1), _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "2"
    }
  }, [_vm._v(" 총 합계 ")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "10"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-24"
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(parseInt(_vm.totalAmount).format()))])])])], 1)], 1), _c('v-divider', {
    staticClass: "border-2"
  }), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px grey--text text--darken-3"
  }, [_vm._v("mdi-gift-outline")]), _c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("선물하기")])], 1)], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "color": "secondary"
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-cart-outline")]), _vm._v("장바구니")], 1)], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-shopping-outline")]), _vm._v("바로구매")], 1)], 1)], 1)], 1)] : _vm._e()], 2)])], 1), _c('v-divider', {
    staticClass: "d-none d-lg-block"
  }), _c('div', {
    staticClass: "pt-10px pt-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_c('v-icon', {
    staticClass: "mr-4px mr-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v("이전상품보기")], 1)])], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_vm._v("다음상품보기"), _c('v-icon', {
    staticClass: "ml-4px ml-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)])], 1)], 1)], 1)], 1)]), _c('v-divider'), _c('v-responsive', [_c('v-card', [_c('v-tabs', {
    staticClass: "pa-0",
    attrs: {
      "show-arrows": "",
      "grow": ""
    }
  }, [_c('v-tab', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "height": "100%"
    }
  }, [_vm._v("기대평/리뷰")])], 1), _c('v-tab', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "height": "100%"
    }
  }, [_vm._v("상품문의")])], 1), _c('v-tab', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "height": "100%"
    }
  }, [_vm._v("상품정보")])], 1), _c('v-tab', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "height": "100%"
    }
  }, [_vm._v("교환/환불/배송")])], 1)], 1), _c('div', {
    staticClass: "mt-4 pt-12",
    attrs: {
      "id": "product-content"
    }
  }), _c('v-responsive', [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/products/gift-guide.jpg"
    }
  }), _c('p', {
    staticClass: "pa-4",
    domProps: {
      "innerHTML": _vm._s((_vm$value10 = _vm.value) === null || _vm$value10 === void 0 ? void 0 : _vm$value10.content)
    }
  })], 1)], 1)], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }